import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useCities } from "@/lib/queries";

export const CityList = ({ limit }) => {
  const { data: cities = [] } = useCities();
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const t = q.trim().toLowerCase();
    const f = t ? cities.filter((c) => c.name.toLowerCase().includes(t) || c.state.toLowerCase().includes(t)) : cities;
    return limit && !t ? f.slice(0, limit) : f;
  }, [cities, q, limit]);
  return (
    <div>
      <div className="relative max-w-md mb-6">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your city or state" className="h-12 pl-11 rounded-full" data-testid="city-search-input" />
      </div>
      <div className="flex flex-wrap gap-2" data-testid="city-list">
        {list.map((c) => (
          <Link key={c.slug} to={`/cities/${c.slug}`} data-testid={`city-chip-${c.slug}`} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-4 py-2 text-sm hover:border-primary hover:text-primary transition-colors">
            <MapPin className="h-3.5 w-3.5 text-primary" />{c.name}
          </Link>
        ))}
        {list.length === 0 && <p className="text-sm text-muted-foreground" data-testid="city-empty">Not listed yet? Call us — we're expanding fast.</p>}
      </div>
    </div>
  );
};
